import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from '../environments/environment';
import {Router, ActivatedRoute} from '@angular/router';
import {MatSnackBarModule,MatSnackBar,MatSnackBarRef,MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';


import {ApiService} from './api_service/api.service';
import {RoleService} from './role.service';
import {LoggedinService} from './loggedin.service';
import {LoggedinServiceBehavior} from './loggedinbehavior.service';

import {JwtHelperService} from '@auth0/angular-jwt';
import {Observable, interval, pipe} from 'rxjs';
import {CurrentRouteService} from "./currentRoute.service";
import { SnackBarService } from './snackBar.service';
import {AuthService} from "./login/auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  isLoggedIn = false;
  li_sub: any;
  role_sub: any;
  role_link: any;
  poll_sub : any;
  sb_sub:any;
  role: string;
  my_email: string;
  currentroute_sub: any;
  current_route: string;
  title = 'Angle';


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private loggedinService: LoggedinService,
    private loggedinServiceBehavior: LoggedinServiceBehavior,
    private _apiService: ApiService,
    private currentrouteService: CurrentRouteService,
    private snackbarService: SnackBarService,
    public snackBar: MatSnackBar,
    private authService: AuthService
  ) {} //end constructor

  ngOnInit(): void {
    this.authService.autoLogin();
    // this.sb_sub = this.snackbarService.snackbarAnnounced$.subscribe(
    //   message => {
    //     console.log('SNACK BAR MESSAGE dude!!!!',message)
    //     this.openSnackBar(message,'');
    //   }); //end role_sub

    // this.roleService.roleAnnounced$.subscribe(
    //   role => {
    //     this.role = role;
    //     console.log('ROLE',this.role);
    //   }
    // ); //end role_sub



  } //end ngOnInit

  ngOnDestroy(): void {
    if (this.sb_sub) {
      this.sb_sub.unsubscribe();
    }
  } //end ngOnDestroy

  // openSnackBar(message: string, action: string) {
  //   console.log('VVVVVVVVV')
  //   let snackBarRef = this.snackBar.open(message, action, {
  //     duration: 5000,
  //   });
  //   snackBarRef.afterDismissed().subscribe(() => {
  //   });
  //   snackBarRef.onAction().subscribe(() => {
  //     this._apiService.refreshToken()
  //   });
  //   snackBarRef.dismiss();
  // } //end openSnackBar



} //end class
